module.exports = __webpack_public_path__ + "img/android.fb547f16.svg";